<template>
    <div>
        <!-- Состояние загрузки -->
        <div v-if="isLoading" class="flex min-h-16 items-center justify-center py-4">
            <loader size="32"></loader>
        </div>

        <!-- Ошибка загрузки -->
        <div v-else-if="error" class="py-4 text-center text-xs text-red-500">
            Ошибка загрузки истории: {{ error }}
        </div>

        <!-- Данные: пустая выдача — без фиктивных событий -->
        <ShiftHistoryList v-else />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import ShiftHistoryList from './ShiftHistoryList.vue'

const store = useScheduleStore()
const isLoading = ref(false)
const error = ref<string | null>(null)

const shiftId = computed(() => store.currentShift?.id)

// История показывается во вкладке редактора (RD-140): загружается при открытии вкладки и смене карточки.
const loadShiftHistory = async () => {
    if (!shiftId.value) return

    isLoading.value = true
    error.value = null

    try {
        const result = await store.fetchShiftHistory(shiftId.value)
        // Store возвращает ошибку запроса вместо throw.
        if (result instanceof Error) error.value = result.message || 'Неизвестная ошибка'
    } catch (err) {
        error.value = err instanceof Error ? err.message : 'Неизвестная ошибка'
    } finally {
        isLoading.value = false
    }
}

onMounted(loadShiftHistory)

watch(shiftId, async (newId, oldId) => {
    if (newId && newId !== oldId) await loadShiftHistory()
})
</script>
